import "./resource";
import { paymentT } from "../../typings/payment";

export class LinkPaymentService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "linkPaymentResource"
    ];

    constructor(
        protected $log: ng.ILogService,
        protected $q: ng.IQService,
        private linkPaymentResource: any
    ) {}

    public create(saleId: number, linkPaymentPost: paymentT.thor.LinkPaymentPost) {
        return this.linkPaymentResource()
            .create({ saleId }, linkPaymentPost)
            .$promise
            .catch((error: any) => this.$q.reject(error));
    }

    public update(saleId: number, linkId: number, opts: any) {
        return this.linkPaymentResource()
            .update({ saleId, linkId })
            .$promise
            .catch((error: any) => this.$q.reject(error));
    }

    public delete(saleId: number, linkId: number) {
        return this.linkPaymentResource()
            .delete({ saleId, linkId })
            .$promise
            .catch((error: any) => this.$q.reject(error));
    }
}

angular
    .module("thor.core.link-payment.service", [
        "thor.core.link-payment.resource"
    ])
    .service("linkPaymentService", LinkPaymentService);
